module.exports = __webpack_public_path__ + "static/Protected-570030c85249691a12d7e880bc291d2d.png";